<template>
  <div class="container">
    <div class="card-wrap">
      <div class="subtitle" style="color: #000;">
        {{ mwActive.graveName }}{{ mwActive.sizhe }}
      </div>
      <div class="subtitle">商品清单</div>
      <div class="list-wrap">
        <div class="list-item" v-for="(item, index) in list" :key="index">
          <div class=" dis-flex ">
            <img class="list-item_left" :src="item.tradeCoverPhoto" />
            <div class="list-item_right">
              <div>{{ item.tradeName }}</div>
              <div>{{ item.price }}</div>
              <div>x{{ item.amount }}</div>
              <div style="font-size: 13px;">
                总计：<span style="color: red;font-size: 19px;">￥ {{ item.totalPrice }}</span>
              </div>
            </div>
          </div>
          <div class="charged-content" v-if="item.additionalInfo">
            收费内容：
            <div class="span" v-for="item in JSON.parse(item.additionalInfo)" :key="item">
              {{ item }}
            </div>
          </div>
          <div style="margin-top:8px">
            反馈内容：{{ allInfo.feedbackContent }}
            <van-grid :border="false" :column-num="2">
              <van-grid-item v-for="(item, index) in imgList" :key="index" style="height:140px"
                @click="priviewImg(imgList, index)" fit="fill">
                <van-image :src="item" style="height:100%;width:100%;object-fit: cover" />
              </van-grid-item>
            </van-grid>
            <div class="imgList-home">
              <div class="imgList-title">
                视频：
              </div>
              <van-button plain type="primary" size="mini" v-for="(item, index) in videoList" :key="index"
                @click="videoById(item)">视频{{ index + 1 }}</van-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-wrap">
      <div class="card-wrap_top dis-flex flex-x-between">
        <div>{{ list.length }}件商品，合计：</div>
        <div style="color: red;font-size: 19px;">
          ￥{{ allInfo.totalPrice }}
        </div>
      </div>
    </div>
    <van-cell-group>
      <van-field v-model="allInfo.contactPhone" label="手机号" readonly />
    </van-cell-group>
    <van-cell-group>
      <van-field type="textarea" v-model="remark" label="备注" placeholder="请输入留言" rows="2" autosize />
    </van-cell-group>
    <div v-if="allInfo.status == 0">
      <div class="btns dis-flex flex-x-between">
        <div class="btn" @click="cancelBuy">取消订单</div>
        <div class="btn submit" @click="buyNow">立即支付</div>
        <!-- <div class="btn submit" @click="buyNow2">立即支付2</div> -->
      </div>
      <div class="text" style="color: red;">
        付款确认页，可以直接支付，或联系墓园修改价格！修改成功后再次打开订单页面支付即可！
      </div>
      <div class="text">
        联系电话：四墓园，86530202；五墓园，86530267；六墓园，86506333；神钟山，86520506；
      </div>
    </div>
    <div class="btns" v-if="allInfo.pdf">
      <a :href="allInfo.pdf" download="电子发票.pdf">下载发票</a>
      <!-- <div class="btn" @click="printInvoice" v-if="appSource == iOS">
        下载发票
      </div> -->
    </div>
    <div class="video-mask" v-if="mask" @click="maskClose">
      <div class="item">
        <div class="item-top"  @click="maskClose">
          关闭视频
        </div>
       <div class="video-home">
        <video width="400px" height="200px" :src="videoUrl" controls>

</video>
       </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  storeOrderInfo,
  launchPay,
  closeOrder,
  getInvoiceList
} from '@/api/good'
import { Grid, GridItem } from 'vant'
import { ImagePreview } from 'vant'
import { getStore } from '@/utils/store'
import { Toast } from 'vant'
import { appid } from '@/utils/config'
import { downloadFileBlob } from '@/utils/util'
import print from 'print-js'

export default {
  components: {},
  data() {
    return {
      mask: false,
      remark: '',
      mwActive: {},
      list: [],
      allInfo: {},
      orderId: null,
      orderActive: null,
      imgList: [], //反馈内容图片
      videoList: [],//反馈视频
      baseUrl: process.env.VUE_APP_BASE_API
    }
  },
  methods: {
    maskClose() {
      this.mask = false
      this.videoUrl = ''
    },
    videoById(data) {
      this.videoUrl = data
      this.mask = true
    },
    // appSource() {
    //   let client = ''
    //   if (/(iOS|iPhone|iPad|iPod)/i.test(navigator.userAgent)) {
    //     return (client = 'iOS')
    //   } else if (/(Android)/i.test(navigator.userAgent)) {
    //     return (client = 'Android')
    //   } else {
    //     return (client = 'Android')
    //   }
    //   return client
    // },
    priviewImg(item, index) {
      ImagePreview({ images: item, startPosition: index })
    },
    // 打印发票
    printInvoice() {
      getInvoiceList({ invoice: this.allInfo.invoice }).then((res) => {
        downloadFileBlob(`/api${res.data}`, '电子发票.pdf')
      })
    },
    getDetail() {
      storeOrderInfo(this.orderId).then((res) => {
        this.allInfo = res.data
        this.list = res.data.detailList
        this.imgList = res.data.imgList
        this.videoList = res.data.videoList
      })
    },
    buyNow() {
      const loading = this.$loading({
        lock: true,
        text: '调起微信支付中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      launchPay({ orderId: this.orderId, price: this.allInfo.totalPrice, remark: this.remark })
        .then((res) => {
          const { data } = res
          WeixinJSBridge.invoke(
            'getBrandWCPayRequest',
            {
              appId: appid, //公众号ID，由商户传入
              timeStamp: data.timeStamp, //时间戳，自1970年以来的秒数
              nonceStr: data.nonceStr, //随机串
              package: data.package,
              signType: data.signType, //微信签名方式：
              paySign: data.paySign //微信签名
            },
            function (res) {
              if (res.err_msg == 'get_brand_wcpay_request:ok') {
                // 使用以上方式判断前端返回,微信团队郑重提示：
                //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
              }
            }
          )
          // wx.chooseWXPay({
          //   timestamp: data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
          //   nonceStr: data.nonceStr, // 支付签名随机串，不长于 32 位
          //   package: data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
          //   signType: data.signType, // 微信支付V3的传入RSA,微信支付V2的传入格式与V2统一下单的签名格式保持一致
          //   paySign: data.paySign, // 支付签名
          //   success: function(res) {
          //     // 支付成功后的回调函数
          //     this.$router.push({
          //       name: 'myOrders',
          //     });
          //   },
          // });
        })
        .finally(() => {
          loading.close()
        })
    },
    // buyNow2() {
    //   const loading = this.$loading({
    //     lock: true,
    //     text: '调起微信支付中...',
    //     spinner: 'el-icon-loading',
    //     background: 'rgba(0, 0, 0, 0.7)',
    //   });
    //   launchPay({ orderId: this.orderId }).then((res) => {
    //     const { data } = res;
    //     loading.close();
    //     wx.config({
    //       debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    //       appId: appid, // 必填，公众号的唯一标识
    //       timestamp: data.timeStamp, // 必填，生成签名的时间戳
    //       nonceStr: data.nonceStr, // 必填，生成签名的随机串
    //       signature: data.paySign, // 必填，签名
    //       jsApiList: ['chooseWXPay'], // 必填，需要使用的JS接口列表
    //     });
    //     wx.ready(function() {
    //       wx.chooseWXPay({
    //         timestamp: data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
    //         nonceStr: data.nonceStr, // 支付签名随机串，不长于 32 位
    //         package: data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
    //         signType: data.signType, // 微信支付V3的传入RSA,微信支付V2的传入格式与V2统一下单的签名格式保持一致
    //         paySign: data.paySign, // 支付签名
    //         success: function(res) {
    //           // 支付成功后的回调函数
    //           this.$router.push({
    //             name: 'myOrders',
    //           });
    //         },
    //       });
    //     });
    //   });
    // },
    cancelBuy() {
      closeOrder({ orderIds: this.orderId }).then((res) => {
        Toast({
          message: '取消订单成功!',
          type: 'success',
          onClose: () => {
            this.$router.push({
              name: 'myOrders'
            })
          }
        })
      })
    }
  },
  created() {
    this.mwActive = getStore({ name: 'mwActive' })
    this.orderId = this.$route.query.id
    // this.appSource()
    // this.orderActive = this.$route.query.active
  },
  props: {},
  watch: {},
  computed: {},
  mounted() {
    this.getDetail()
  }
}
</script>

<style scoped lang="scss">
.van-cell {
  display: block;
  padding: 0 10px;
  border: 1px solid #ebedf0;
}

.container {
  padding: 0 0 6%;
  color: #455a64;

  .card-wrap {
    background: #fff;
    padding: 8px 12px;
    margin-bottom: 10px;
  }

  .subtitle {
    padding: 8px 0;
    border-top: 1px solid #ebedf0;
    border-bottom: 1px solid #ebedf0;
    font-size: 14px;
  }

  .list-wrap {
    .list-item {
      padding: 8px 0;
      box-sizing: border-box;
      background: #fff;
      position: relative;

      .list-item_left {
        width: 135px;
        height: 150px;
        padding-right: 10px;
      }

      .list-item_right {
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;

        div:nth-child(1) {
          height: 25px;
          line-height: 25px;
          font-size: 16px;
          font-weight: bold;
          color: #303133;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        div:nth-child(2) {
          height: 35px;
          line-height: 35px;
          font-size: 20px;
          color: #465cff;
          font-weight: 900;
        }

        div:nth-child(3) {
          font-size: 14px;
          color: #606266;
          overflow: hidden;
          text-overflow: ellipsis;
          flex: 1;
        }
      }

      .charged-content {
        font-size: 14px;

        .span {
          color: red;
          font-size: 13px;
        }
      }
    }
  }

  .card-wrap_top {
    font-size: 15px;
    // padding: 10px 0;
  }

  .charge-inclusion {
    color: red;
    font-size: 13px;
  }

  .card-wrap_bottom {
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;
    border-top: 1px solid #ebedf0;
    border-bottom: 1px solid #ebedf0;

    :nth-child(2) {
      color: red;
      font-weight: bold;
    }
  }

  .btns {
    width: 90%;
    margin: 15px auto;

    .btn {
      --height: 40px;
      text-align: center;
      width: 45%;
      height: var(--height);
      line-height: var(--height);
      font-size: 16px;
      background: #fff;
      color: #76bc1e;
      border-radius: 3px;

      &.submit {
        color: #fff;
        background: #76bc1e;
      }
    }
  }

  .text {
    font-size: 13px;
    padding: 0 7px;
    box-sizing: border-box;

    &:last-child {
      margin-top: 5px;
    }
  }
}

.video-mask {
  width: 100%;
  height: 100%;
  background-color: #303133;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;

  .item {


    .item-top {
      font-size: 14px;
      color: white;
      text-align: right;
      margin-right: 10px;
      margin-top: 30px;
      margin-bottom: 20px;
    }
    .video-home{
      display: flex;
      justify-content: center;
    }
  }
}

.imgList-title {
  font-size: 12px;
  margin-top: 5px;
  margin-bottom: 5px;
}</style>
